import { PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "app/containers/Features/components/MemberSelection/redux/initialState";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import { createSlice } from "utils/@reduxjs/toolkit";

const useMemberListSlice = createSlice({
  name: "memberListSlice",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    fetchTeamMembersList: (
      state,
      action: PayloadAction<{
        id: string;
        callback: () => void;
      }>,
    ) => {
      state.isLoading = true;
    },
    fetchProjectMembersList: (
      state,
      action: PayloadAction<{ id: string; callback?: () => void }>,
    ) => {
      state.isLoading = true;
    },
    setTeamMemberList: (state, action: PayloadAction<IMemberList[]>) => {
      state.teamMemberList = action.payload;
    },
    setProjectMemberList: (state, action: PayloadAction<IMemberList[]>) => {
      state.projectMemberList = action.payload;
    },
    removeProjectMemberLocally: (
      state,
      action: PayloadAction<{ projectMemberId: string }>,
    ) => {
      const { projectMemberId } = action.payload;
      state.projectMemberList = state.projectMemberList.filter(
        (member) => member._id !== projectMemberId,
      );
    },
    removeTeamMemberLocally: (
      state,
      action: PayloadAction<{ teamMemberId: string }>,
    ) => {
      const { teamMemberId } = action.payload;
      state.teamMemberList = state.teamMemberList.filter(
        (member) => member._id !== teamMemberId,
      );
    },
    updateTeamMemberLocally: (
      state,
      action: PayloadAction<{
        teamMemberId: string;
        changes: Partial<IMemberList>;
      }>,
    ) => {
      const { teamMemberId, changes } = action.payload;
      state.teamMemberList = state.teamMemberList.map((member) => {
        if (member._id === teamMemberId) {
          return { ...member, ...changes };
        }
        return member;
      });
    },
  },
});
export const {
  actions,
  reducer: memberListReducer,
  name: memberListSlice,
} = useMemberListSlice;
